export * from './directConvolution';
export * from './fftConvolution';

export const BorderType = {
  CONSTANT: 'CONSTANT',
  CUT: 'CUT'
};
